import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import api from "./api.service";
const apiService = new api();

const API_HOST = process.env.VUE_APP_THERM_API_HOST;

Vue.use(Vuex);
function update_vector_count(state) {
  if (state.draw) {
    let filtered_features = [];
    for (let layer of Object.values(state.active_layers)) {
      if (layer.is_vector_active) filtered_features.push(...layer.filtered_features);
    }
    const all_vectors = [...state.draw.getAll().features, ...filtered_features];
    const vector_count = _.countBy(all_vectors, (vec) => vec.properties.class_id);
    for (let v of Object.values(state.vectors)) {
      state.vectors[v.class_id].count = vector_count[v.class_id] || 0;
    }
  }
}
async function update_project_elements(state, layer) {
  let project_details = state.active_layers[layer.projectUid].project_details;
  if (!project_details) {
    let response = await apiService.get_project_details({
      group_id: layer.groupUid,
      id: layer.projectUid,
    });
    project_details = response.data;
  }
  if (_.isString(project_details.element)) {
    let element = await apiService.get_element({ url: project_details.element });
    project_details.element = element.data;
  }
  state.active_layers[layer.projectUid]["project_details"] = project_details;

  try {
    if (state.active_layers[layer.projectUid].project_elements) return;
    // else
    state.active_layers[layer.projectUid].project_elements = [];
    let response = await apiService.get_project_elements({
      id: layer.projectUid,
    });
    if (response.data) state.active_layers[layer.projectUid].project_elements = response.data;
  } catch (err) {
    console.log(err);
  }
}

let check_split_permissions = (treatment) => {
  if (treatment == "on") {
    return true;
  } else if (treatment == "off") {
    return false;
  } else {
    return true;
  }
};
export default new Vuex.Store({
  state: {
    is_loading: false,
    api_host: API_HOST,
    token: null,
    claims: null,
    orthos: [],
    map: null,
    raw_images_map: null,
    draw: null,
    vectors: {},
    active_layer: null,
    cluster_active_layer: null,
    active_layers: {},
    layer_features: {},
    layer_filtered_features: [],
    temperature_filtered_features: [],
    selected_features: null,
    temeprature_difference: null,
    mapbox_token: null,
    current_organization: {},
    temp_data: [],
    view_details: {},
    split_client: null,
    fly_active: true,
    mapstyle: localStorage.getItem("mapstyle") || "satellite",
    lang_data: null,
  },
  mutations: {
    SET_LANG_DATA(state, data) {
      state.lang_data = data;
    },
    UPDATE_ACTIVE_LAYERS(state, data) {
      state.active_layers = data;
    },
    SET_MAPSTYLE(state, value) {
      state.mapstyle = value;
      localStorage.setItem("mapstyle", state.mapstyle);
    },
    TOGGLE_FLY_STATE(state, value) {
      state.fly_active = value;
    },
    SET_SPLIT_CLIENT(state, split_client) {
      state.split_client = split_client;
    },
    SET_VIEW_DETAILS(state, value) {
      state.view_details = value;
    },
    SET_CLUSTER_ACTIVE_LAYER(state, value) {
      state.cluster_active_layer = value;
    },
    SET_TEMP_DATA(state, val) {
      state.temp_data = val;
    },
    SET_MAPBOX_TOKEN(state, val) {
      state.mapbox_token = val;
    },

    SET_RAW_IMAGES_MAP(state, val) {
      state.raw_images_map = val;
    },
    async LOAD_SOURCES(state, data) {
      try {
        state.is_loading = true;
        for (let [i, group] of state.orthos.entries()) {
          for (let [j, project] of group.entries()) {
            if (!state.map.getSource("MAPSOURCE:" + String(project.projectUid)))
              state.map.addSource("MAPSOURCE:" + String(project.projectUid), {
                type: "raster",
                tiles: [`${project.orthoTiles}/{z}/{x}/{y}.png`],
                tileSize: 256,
              });
            state.active_layers[project.projectUid] = {};
            state.active_layers[project.projectUid].is_ortho_active = false;
            state.active_layers[project.projectUid].is_vector_active = false;
            state.active_layers[project.projectUid].info = project;
            state.active_layers[project.projectUid].features = [];
            state.active_layers[project.projectUid].tables = [];
            state.active_layers[project.projectUid].filtered_features = [];
            state.active_layers[project.projectUid].temperature_filtered_features = [];

            if (project.orthoTiles) {
              
              if(state.active_layers[project.projectUid] && !state.active_layers[project.projectUid].meta){
                let results  = await apiService.get(project.orthoTiles);
                state.active_layers[project.projectUid].meta = results.data;
              }
              if (!j && !i) {
                state.map.addLayer(
                  {
                    id: "MAPLAYER:" + String(project.projectUid),
                    type: "raster",
                    source: "MAPSOURCE:" + String(project.projectUid),
                  },
                  "gl-draw-polygon-fill-inactive.cold"
                );
                state.active_layers[project.projectUid].is_ortho_active = true;
                if (state.active_layers[project.projectUid] && state.active_layers[project.projectUid].meta.center)
                  state.map.flyTo({
                    center: state.active_layers[project.projectUid].meta.center.slice(0, 2),
                    zoom: 15,
                    speed: 4,
                  });
              }
            }
          }
        }
        state.active_layers = { ...state.active_layers };
        state.is_loading = false;
      } catch (err) {
        console.log("ERR");
        state.is_loading = false;

        parent.postMessage("token_expired", "*");
      }
    },
    async SET_ACTIVE_LAYER(state, data) {
      let { opacity } = data;
      let layer = state.active_layers[String(data.layer.projectUid)];
      state.active_layers[String(data.layer.projectUid)].is_ortho_active = data.active;

      if (!state.map.getSource("MAPSOURCE:" + String(layer.info.projectUid))) {
        state.map.addSource("MAPSOURCE:" + String(layer.info.projectUid), {
          type: "raster",
          tiles: [`${layer.info.orthoTiles}/{z}/{x}/{y}.png`],
          tileSize: 256,
        });
      }

      if (data.style_change) {
        state.map.removeLayer("MAPLAYER:" + String(layer.info.projectUid));
      }

      if (layer && data.active == false) {
        if (state.map.getLayer("MAPLAYER:" + String(layer.info.projectUid)))
          state.map.setLayoutProperty("MAPLAYER:" + String(layer.info.projectUid), "visibility", "none");
      } else {
        if (state.map && state.map.getLayer("MAPLAYER:" + String(layer.info.projectUid)))
          state.map.setLayoutProperty("MAPLAYER:" + String(layer.info.projectUid), "visibility", "visible");
        else
          state.map.addLayer(
            {
              id: "MAPLAYER:" + String(layer.info.projectUid),
              type: "raster",
              source: "MAPSOURCE:" + String(layer.info.projectUid),
              paint: {
                "raster-opacity": parseInt(opacity, 10) / 100,
              },
            },
            "gl-draw-polygon-fill-inactive.cold"
          );
      }
      await update_project_elements(state, data.layer);
      state.active_layers = { ...state.active_layers };
      update_vector_count(state);
    },
    async SET_GROUP_VECTOR(state, data) {
      try {
        state.is_loading = true;
        let projectsuids = data.group.map((p) => {
          return p.projectUid;
        });
        let to_remove = _.filter(
          state.draw.getAll().features,
          (feature) => feature.properties.class_name !== "table" && _.includes(projectsuids, feature.properties.projectUid)
        );

        const filtered_featureIds = _.map(to_remove, (feature) => feature.id);
        state.draw.delete(filtered_featureIds);
        for (let layer of data.group) {
          state.active_layers[layer.projectUid].is_vector_active = data.active;
        }
        if (data.active) {
          let all_features = [];
          for (let layer of data.group) {
            let { features } = state.active_layers[layer.projectUid];

            if (data.active == true) {
              if (features && features.length) {
                all_features.push(...features);
              } else {
                let results = await apiService.get(layer.vectors + "?tables=false");
                state.active_layers[layer.projectUid].features = results.data.features.map((feature) => {
                  feature.properties["projectUid"] = layer.projectUid;
                  feature.properties["project_details"] = layer;
                  return feature;
                });
                all_features.push(...state.active_layers[layer.projectUid].features);
              }
            }
          }
          state.draw.add({ type: "FeatureCollection", features: all_features });
        }
        state.is_loading = false;
        update_vector_count(state);
      } catch (err) {
        state.is_loading = false;
        parent.postMessage("token_expired", "*");
      }
    },
    async SET_LAYER_VECTOR(state, data) {
      try {
        if (state.active_layers[data.layer.projectUid].is_vector_active === data.active) return;

        state.is_loading = true;
        let { features } = state.active_layers[data.layer.projectUid];

        state.active_layers[data.layer.projectUid].is_vector_active = data.active;

        if (data.active == false) {
          let to_remove = _.filter(
            state.draw.getAll().features,
            (feature) => feature.properties.projectUid === data.layer.projectUid && feature.properties.class_name !== "table"
          );
          let filtered_featureIds = _.map(to_remove, (feature) => feature.id);
          state.draw.delete(filtered_featureIds);
        }
        if (data.active == true) {
          if (features && features.length) {
            state.draw.add({ type: "FeatureCollection", features });
          } else {
            let results = await apiService.get(data.layer.vectors + "?tables=false");
            state.active_layers[data.layer.projectUid].features = results.data.features.map((feature) => {
              feature.properties["projectUid"] = data.layer.projectUid;
              feature.properties["project_details"] = data.layer;
              return feature;
            });
            state.draw.add({ type: "FeatureCollection", features: state.active_layers[data.layer.projectUid].features });
          }
        }
        state.is_loading = false;
        update_vector_count(state);
      } catch (err) {
        console.log("ERR");
        state.is_loading = false;
        parent.postMessage("token_expired", "*");
      }
    },
    async SET_GROUP_TABLES(state, data) {
      try {
        state.is_loading = true;
        let { group, active } = data;
        // if (!active) {
        let to_remove_ids = [];
        let draw_features = state.draw.getAll().features;
        for (let layer of group) {
          let to_remove = _.filter(
            draw_features,
            (feature) => feature.properties.class_name === "table" && feature.properties.projectUid == layer.projectUid
          );

          to_remove_ids.push(..._.map(to_remove, (feature) => feature.id));
        }
        state.draw.delete(to_remove_ids);
        // state.is_loading = false;
        // return;
        // }
        if (active) {
          let tables_to_add = [];
          for (let layer of group) {
            if (!state.active_layers[layer.projectUid].tables.length) {
              let results = await apiService.get(layer.vectors + "?issues=false");
              let mapped_results = results.data.features.map((feature) => {
                feature.properties["projectUid"] = layer.projectUid;
                return feature;
              });
              state.active_layers[layer.projectUid].tables = mapped_results;
              tables_to_add.push(...mapped_results);
            } else {
              tables_to_add.push(...state.active_layers[layer.projectUid].tables);
            }
          }
          state.draw.add({ type: "FeatureCollection", features: tables_to_add });
        }
        update_vector_count(state);
        state.is_loading = false;
      } catch (err) {
        console.log("ERR");
        state.is_loading = false;
        parent.postMessage("token_expired", "*");
      }
    },
    async SET_LAYER_TABLES(state, data) {
      try {
        state.is_loading = true;
        let { layer, active } = data;
        if (active && !state.active_layers[layer.projectUid].tables.length) {
          let results = await apiService.get(layer.vectors + "?issues=false");
          let mapped_results = results.data.features.map((feature) => {
            feature.properties["projectUid"] = layer.projectUid;
            return feature;
          });
          state.active_layers[layer.projectUid].tables = mapped_results;
        }
        if (active) {
          let to_add = state.active_layers[layer.projectUid].tables;
          state.draw.add({ type: "FeatureCollection", features: to_add });
        } else {
          let to_remove = _.filter(
            state.draw.getAll().features,
            (feature) => feature.properties.class_name === "table" && feature.properties.projectUid == layer.projectUid
          );
          let filtered_featureIds = _.map(to_remove, (feature) => feature.id);
          state.draw.delete(filtered_featureIds);
          state.active_layers[layer.projectUid].tables = to_remove;
        }
        update_vector_count(state);
        state.is_loading = false;
      } catch (err) {
        console.log("ERR");
        state.is_loading = false;

        parent.postMessage("token_expired", "*");
      }
    },
    FILTER_LAYER_VECTOR(state, data) {
      let { class_id, active } = data;
      for (let layer of Object.values(state.active_layers)) {
        state.active_layers[layer.info.projectUid].is_vector_active = active;
        if (layer.is_vector_active) {
          let to_add = _.remove(
            state.active_layers[layer.info.projectUid].filtered_features,
            (feature) => feature.properties.class_id === class_id && feature.properties.projectUid === layer.info.projectUid
          );
          state.draw.add({ type: "FeatureCollection", features: to_add });
        } else {
          let to_remove = _.filter(
            state.draw.getAll().features,
            (feature) => feature.properties.class_id === class_id && feature.properties.projectUid === layer.info.projectUid
          );
          let filtered_featureIds = _.map(to_remove, (feature) => feature.id);
          state.draw.delete(filtered_featureIds);
          state.active_layers[layer.info.projectUid].filtered_features.push(...to_remove);
        }
      }
    },
    UPDATE_TEMPERATURE_FILTERED_FEATURES(state, range) {
      let in_range_features = [];
      let all_features = state.draw.getAll().features;
      for (let layer of Object.values(state.active_layers)) {
        in_range_features.push(
          ..._.remove(
            layer.temperature_filtered_features,
            (feature) => feature.properties.temperature_difference >= range[0] && feature.properties.temperature_difference <= range[1]
          )
        );

        layer.temperature_filtered_features.push(
          ..._.remove(
            all_features,
            (feature) =>
              feature.properties.projectUid == layer.info.projectUid &&
              (feature.properties.temperature_difference < range[0] || feature.properties.temperature_difference > range[1]) &&
              feature.properties.class_name !== "table"
          )
        );
      }
      const geojson = {
        type: "FeatureCollection",
        features: [...all_features, ...in_range_features],
      };
      state.draw.set(geojson);
      update_vector_count(state);
    },
    UPDATE_VECTOR_COUNT(state) {
      update_vector_count(state);
    },
    SET_SELECTED_FEATURES(state, features) {
      state.selected_features = features;
    },
    SET_TOKEN(state, value) {
      if (value) {
        state.token = "jwt " + value;
      }
    },
    SET_CLAIMS(state, value) {
      if (!value) return;

      state.claims = value;
      // setting for guest user
      let cookies_organization = window.$cookies.get("user_organization");
      if (cookies_organization) {
        cookies_organization = JSON.parse(atob(cookies_organization));
        state.current_organization = cookies_organization;
        window.current_organization = state.current_organization;
      }
    },
    INIT_MAP(state, map) {
      state.map = map;
    },
    INIT_DRAW(state, draw) {
      state.draw = draw;
    },
    INIT_VECTORS(state, vectors) {
      state.vectors = vectors;
    },
    UPDATE_ORTHOS(state, orthos) {
      state.orthos = orthos;
    },
    SET_ORTHOS(state, orthos) {
      let grouped_orthos = {};
      orthos.forEach((element) => {
        grouped_orthos[element.groupUid] ? grouped_orthos[element.groupUid].push(element) : (grouped_orthos[element.groupUid] = [element]);
      });
      state.orthos = Object.values(grouped_orthos);

      if (!state.orthos || !state.orthos.length) state.orthos = [];
      else {
        state.orthos = _.sortBy(state.orthos, [(g) => g[0].groupName.toLowerCase()]);

        for (let i in state.orthos) {
          state.orthos[i] = _.orderBy(state.orthos[i], [(p) => (p.properties || {}).date, (p) => p.projectName], ["desc", "asc"]);

          // _.sortBy(state.orthos[i], [(p) => p.projectName.toLowerCase()]);
        }
      }
    },
    INIT_FEATURE_COLORS(state, stops) {
      // POLYGON FILL STYLES
      state.map.setPaintProperty("gl-draw-polygon-fill-active.cold", "fill-color", {
        property: "user_class_id",
        stops: stops,
      });
      state.map.setPaintProperty("gl-draw-polygon-fill-inactive.cold", "fill-opacity", 0);
      state.map.setPaintProperty("gl-draw-polygon-fill-inactive.hot", "fill-opacity", 0);
      state.map.setPaintProperty("gl-draw-polygon-fill-active.cold", "fill-opacity", 0.25);

      state.map.setPaintProperty("gl-draw-polygon-fill-active.hot", "fill-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-polygon-fill-active.hot", "fill-opacity", 0.25);

      // POLYGON LINE STYLES
      state.map.setPaintProperty("gl-draw-polygon-stroke-inactive.cold", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-polygon-stroke-inactive.hot", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-polygon-stroke-active.cold", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-polygon-stroke-active.hot", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      // LINE STYLES
      state.map.setPaintProperty("gl-draw-line-inactive.cold", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-line-inactive.hot", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-line-active.cold", "line-color", {
        property: "user_class_id",
        stops: stops,
      });

      state.map.setPaintProperty("gl-draw-line-active.hot", "line-color", {
        property: "user_class_id",
        stops: stops,
      });
    },
  },
  actions: {
    get_vectors({ state }, uid) {
      return apiService.get(`${state.api_host}/viewer/view/${uid}/config`);
    },
    set_active_layer({ commit, state }, data) {
      window.map = state.map;
      if (!data.style_change && state.map && state.draw && !state.map.getSource("MAPSOURCE:" + String(data.layer.projectUid))) {
        commit("LOAD_SOURCES");
      } else if (state.map && state.draw) {
        commit("SET_ACTIVE_LAYER", data);
      }
    },
    get_orthos({ state }, uid) {
      return apiService.get(`${state.api_host}/viewer/view/${uid}/initial`);
    },
    get_report_url({ state }, project) {
      return apiService.get(project.report);
    },
  },
  getters: {
    show_publish(state) {
      if (state.claims && state.claims.user_role && ["hacker", "manager_team", "gis_team"].includes(state.claims.user_role.name)) {
        return true;
      }
      return false;
    },
    // split
    tickets_clustering(state) {
      if (state.split_client && state.claims) {
        return check_split_permissions(state.split_client.getTreatment("tickets_clustering", state.claims));
      }
      return false;
    },
    debug(state) {
      if (state.split_client && state.claims) {
        return check_split_permissions(state.split_client.getTreatment("debug", state.claims));
      }
      return false;
    },
    // split
    localization(state) {
      if (state.split_client) {
        return check_split_permissions(state.split_client.getTreatment("localization", state.claims));
      }
    },
    therm_v2(state) {
      if (state.split_client) {
        return check_split_permissions(state.split_client.getTreatment("therm_v2", state.claims));
      }
    },
    has_tickets_app_access(state) {
      if (state.claims) {
        return state.claims.app_permissions && state.claims.app_permissions.tickets;
      }
      return false;
    },
    has_vault_app_access(state) {
      if (state.claims) {
        return state.claims.app_permissions && state.claims.app_permissions.vault;
      }
      return false;
    },
  },
});
